/* Bramble & Bolt — product page behaviour: gallery, variants, zoom.
   Without JS the page still works: all images render in a scrollable strip,
   the variant radios submit as normal form fields, and the form posts to /cart. */
(function () {
  'use strict';

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slidesWrap = gallery.querySelector('.bb-gallery__slides');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.bb-gallery__slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.bb-gallery__thumb'));
    var counter = gallery.querySelector('[data-gallery-counter]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!slidesWrap || !slides.length) return;

    function setActive(index) {
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }

    function goTo(index, smooth) {
      if (index < 0 || index >= slides.length) return;
      slidesWrap.scrollTo({ left: slides[index].offsetLeft - slidesWrap.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      setActive(index);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i, true); });
    });

    var scrollTimer = null;
    slidesWrap.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(slidesWrap.scrollLeft / slidesWrap.clientWidth);
        setActive(Math.max(0, Math.min(index, slides.length - 1)));
      }, 80);
    }, { passive: true });

    setActive(0);

    /* Public hook used by variant selection to show a variant's own image */
    gallery.bbShowMedia = function (mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i, true); return; }
      }
    };

    /* Zoom — only where the source image is large enough to be worth zooming */
    var dialog = document.getElementById('bb-zoom-dialog');
    if (dialog && typeof dialog.showModal === 'function') {
      gallery.querySelectorAll('[data-zoom-src]').forEach(function (img) {
        img.addEventListener('click', function () {
          var target = dialog.querySelector('[data-zoom-target]');
          if (!target) return;
          target.src = img.getAttribute('data-zoom-src');
          target.alt = img.getAttribute('alt') || '';
          dialog.showModal();
        });
      });
      var close = dialog.querySelector('[data-zoom-close]');
      if (close) close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    }
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var dataEl = document.getElementById(form.getAttribute('data-variant-data'));
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = form.querySelector('[data-variant-id]');
    var priceHost = document.querySelector('[data-variant-price-wrap] .bb-price');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var skuHost = document.querySelector('[data-variant-sku]');
    var titleHost = document.querySelector('[data-variant-title]');
    var stockHost = form.querySelector('[data-variant-stock]');
    var submit = form.querySelector('[data-add-to-cart]');
    var gallery = document.querySelector('[data-gallery]');
    var moneyFormat = form.getAttribute('data-money-format') || '';
    var compareLabel = document.documentElement.getAttribute('data-compare-label') || '';

    function groupThousands(digits) {
      var out = '';
      for (var i = 0; i < digits.length; i++) {
        if (i > 0 && (digits.length - i) % 3 === 0) out += ',';
        out += digits.charAt(i);
      }
      return out;
    }
    function money(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      var formatted = groupThousands(parts[0]) + '.' + parts[1];
      var open = moneyFormat.indexOf('{{');
      var close = moneyFormat.indexOf('}}');
      if (open !== -1 && close > open) return moneyFormat.slice(0, open) + formatted + moneyFormat.slice(close + 2);
      return formatted;
    }
    function priceHtml(variant) {
      var html = '<span class="bb-price__current">' + money(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="bb-price__compare" aria-hidden="true">' + money(variant.compare_at_price) + '</s>' +
          '<span class="bb-visually-hidden">Was ' + money(variant.compare_at_price) + ', now ' + money(variant.price) + '</span>';
      }
      return html;
    }
    function selectedOptions() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(options) {
      return variants.filter(function (variant) {
        return options.every(function (value, i) { return value === null || variant.options[i] === value; });
      })[0];
    }

    function render(fromUser) {
      var options = selectedOptions();
      var variant = findVariant(options);

      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('input').forEach(function (input) {
          var probe = options.slice();
          probe[index] = input.value;
          input.disabled = !variants.some(function (v) {
            return probe.every(function (value, i) { return value === null || v.options[i] === value; });
          });
        });
        var label = group.querySelector('[data-option-value]');
        var checked = group.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });

      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = submit.getAttribute('data-unavailable-text') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      [priceHost, stickyPrice && stickyPrice.querySelector('.bb-price')].forEach(function (host) {
        if (!host) return;
        host.innerHTML = priceHtml(variant);
        host.classList.toggle('bb-price--sale', !!onSale);
      });

      if (skuHost) skuHost.textContent = variant.sku || '';
      if (titleHost) titleHost.textContent = variant.title || '';

      if (stockHost) {
        stockHost.className = 'bb-stock ' + (variant.available ? 'bb-stock--in' : 'bb-stock--out');
        stockHost.textContent = variant.available ? (stockHost.getAttribute('data-in-text') || 'Available') : (stockHost.getAttribute('data-out-text') || 'Sold out');
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? (submit.getAttribute('data-default-text') || 'Add to basket') : (submit.getAttribute('data-soldout-text') || 'Sold out');
      }
      if (fromUser && gallery && gallery.bbShowMedia && variant.media_id) gallery.bbShowMedia(variant.media_id);

      if (fromUser && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* URL unsupported — selection still works */ }
      }
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-index] input')) render(true);
    });
    render(false);
  });
})();